import * as React from 'react';
import { useDrawer, Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const FacetsDrawerFooter = ({ activeFilterCount , totalNumberOfHits , onClick ,  })=>{
    const { getLabel  } = useIntl();
    const { close  } = useDrawer();
    const handleClick = ()=>{
        close();
        onClick();
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "facets-drawer-footer"
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "facets-drawer-footer__button",
        caption: activeFilterCount > 0 ? `${getLabel('search.filters.showResults')} ${totalNumberOfHits}` : getLabel('search.filters.close'),
        variant: activeFilterCount > 0 ? 'solid' : 'outline',
        onClick: handleClick
    }));
};

export { FacetsDrawerFooter };
//# sourceMappingURL=FacetsDrawerFooter.js.map
